import * as Feather from 'feather-icons';

import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { InboxService } from '../../../../services/inbox/inbox.service';
import { OrganizationConfigService } from '../../../../services/organization-config/organization-config.service';
import { ClockInOutModalComponent } from '../modals/clock-in-out-modal/clock-in-out-modal.component';
import { AccountService } from '../../../../services/account/account.service';

@Component({
  selector: 'app-navigation-side',
  templateUrl: './navigation-side.component.html',
  styleUrls: ['./navigation-side.component.css']
})
export class NavigationSideComponent implements OnInit {

  constructor(
    public inboxService: InboxService,
    public orgConfig: OrganizationConfigService,
    public accountService: AccountService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {}

  public openClockInOutModal() {
    this.modalService.open(ClockInOutModalComponent);
  }

}
